export const DEFAULT_PARAMS: WelcomeScreenParams = {
    countries: [
        { val: '225', text: 'Russia', main: 1 },
        { val: '187', text: 'Ukraine', main: 2 },
        { val: '159', text: 'Kazakhstan', main: 3 },
        { val: '208', text: 'Moldova' },
        { val: '181', text: 'Israel' },
        { val: '246', text: 'Greece' }
    ],
    currencyByCountry: {
        225: ['RUB'],
        187: [],
        159: ['KZT'],
        208: ['EUR', 'RUB', 'USD'],
        181: ['CHF', 'EUR', 'USD'],
        246: ['CHF', 'EUR', 'USD']
    }
};

export interface SelectListItem {
    val: string;
    text: string;
    main?: number;
}

export interface WelcomeScreenParams {
    countries: SelectListItem[];
    currencyByCountry: { [key: string]: string[] };
}

export interface WelcomeScreenData {
    email?: string;
    country?: string;
    currency?: string;
    isAccepted?: boolean;
}

export enum WelcomePageState {
    CountryAndCurrency,
    FirstCampaign
}

export enum WelcomeBannerType {
    AGENCY = 'agency',
    FREELANCER = 'freelancer',
    YANDEX = 'yandex'
}

export interface WelcomeBannerParams {
    suggestYandexService: boolean;
    suggestExternalService: boolean;
    suggestAgencyService: boolean;
}

export const DEFAULT_BANNER_PARAMS: WelcomeBannerParams = {
    suggestYandexService: false,
    suggestExternalService: false,
    suggestAgencyService: false
};
